import React from 'react';
import PropTypes from 'prop-types';
import DownloadAnchorButton from '../../DownloadAnchorButton';
import { capitaliseFirstLetter, updateWithDelimiter } from '../../../util/stringUtils';
import { toPublicResource } from '../../../util/pathUtils';

const PluginVersions = ({
    heading,
    subtitle,
    name,
    versions,
}) => {

    return (
        <div>
            <h3>{heading}</h3>
            {subtitle && <h3>{subtitle}</h3>}
            <p>Supports</p>
            <div>
                <ul>
                    {versions.map((p, i) => {

                        const pluginType = capitaliseFirstLetter(p.pluginType);
                        
                        const zipFileName = `BPOINT_${updateWithDelimiter(name)}-${p.pluginVersion}_${pluginType}.zip`;
                        const pluginPath = toPublicResource(`/media/Plugins/plugins/${zipFileName}`);

                        return <li key={`${pluginType}-${p.platformVersion}${i}`}>
                            <span>{name} version {p.platformVersion}</span>
                            <DownloadAnchorButton
                                text='Download'
                                path={pluginPath}
                                fileName={zipFileName}
                            />
                        </li>
                    })}
                </ul>
            </div>
        </div>
    );

};

DownloadAnchorButton.protoTypes = {
    heading: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    versions: PropTypes.objectOf(PropTypes.shape({
        pluginType: PropTypes.string.isRequired,
        pluginVersion: PropTypes.string.isRequired,
    })),
};

export default PluginVersions;